import * as React from 'react';
import Options from '../../../../../common/components/Options';
import OptionsInsurance from '../../../../../common/components/OptionsInsurance';
import {LOAN_APPLICATION_MX, ERROR} from '../../../../constants/LabelConstants';
import Button from '../../../../../common/components/Button';
import {INPUTS} from '../../../../constants/MX/WizardInputs';
import * as ValidateConstant from '../../../../constants/ValidateConstant';
import LoaderIconBallClipRotate from '../../../../../common/components/loader/LoaderIconBallClipRotate';
import {InsurancesStepProps, InsurancesStepState} from '../../../../types/mx/creditoReal/components';

class InsurancesStepView extends React.Component<InsurancesStepProps, InsurancesStepState> {
    constructor(props) {
        super(props);
        // @ts-ignore
        this.state = {
            showErrors: false,
            selectInsuranceError: this.props.insuranceSelectedTarget ?
                null : ValidateConstant.ERROR_MUST_CHOOSE_INSURANCE
        };
        this.props.getLoanApplication();
    }

    componentDidMount() {
        setTimeout(() => {
            window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
            this.props.onLoad();
        }, 200);
    }

    onPressNext = (skipNipValidation = false) => {
        if (this.props.hasIncludeInsurance && this.state.selectInsuranceError !== null) {
            this.setState({showErrors: true});
        } else {
            this.setState({showErrors: false});
            this.props.onPressNext(skipNipValidation);
        }
    }

    onChangeIncludeInsurance = (value, error, inputId) => {
        this.props.onChangeIncludeInsurance(value);
        this.setState({selectInsuranceError: ValidateConstant.ERROR_MUST_CHOOSE_INSURANCE});
    }

    onChangeInsurance = (value, error, inputId) => {
        this.props.onChangeInsurance(value);
        this.setState({selectInsuranceError: null});
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.insuranceSelectedTarget !== prevProps.insuranceSelectedTarget ||
            prevProps.hasIncludeInsurance !== this.props.hasIncludeInsurance) {
            this.setState({
                selectInsuranceError: this.props.insuranceSelectedTarget ? null
                    : ValidateConstant.ERROR_MUST_CHOOSE_INSURANCE,
                showErrors: prevProps.hasIncludeInsurance !== this.props.hasIncludeInsurance
            });
        }
    }

    showInsuranceLoader = () => {
        return (<div className="row no-gutters pt-2 pb-5">
            <div className="col-auto pr-3">
                <LoaderIconBallClipRotate/>
            </div>
            <div className="col">
                {LOAN_APPLICATION_MX.INSURANCE_IS_LOADING_TEXT}
            </div>
        </div>);
    }

    renderQuotations = (allQuotationInsurances,
                        insuranceSelectedTarget,
                        hasIncludeInsurance,
                        showErrors,
                        selectInsuranceError
                        ) => {
        return (<div className="pb-4">
            <div className="row mb-1">
                <div className="col-12">{LOAN_APPLICATION_MX.INSURANCE_SELECT_COMPANY_TEXT}</div>
            </div>

            <div className="row pt-3 pb-3">
                <div className="col-12 insurances">
                    <div className="rounded border">
                        <div>
                            <OptionsInsurance
                                id={INPUTS.INSURANCE_SELECTED}
                                name={INPUTS.INSURANCE_SELECTED}
                                options={allQuotationInsurances}
                                required={true}
                                insuranceSelectedTarget={insuranceSelectedTarget}
                                onChange={this.onChangeInsurance}/>
                        </div>
                    </div>
                </div>
            </div>
            {hasIncludeInsurance && <div className="row small">
                <div className="col-12">{LOAN_APPLICATION_MX.INSURANCE_PERIOD_FINANCING_TEXT}</div>
            </div>}
            {(showErrors && selectInsuranceError) &&
                <div className="row justify-content-end mb-3">
                    <div className="col-12 form-text is-invalid">{selectInsuranceError}</div>
                </div>}
        </div>);
    }

    renderEmptyQuotations = () => {
        return (<div className="pb-4">
            <div className="row mb-1">
                <div className="col-12 font-weight-bold">POR EL MOMENTO TU SEGURO NO PUEDE SER COTIZADO.</div>
            </div>
            <div className="row mb-1">
                <div className="col-12">El valor de tu seguro será cotizado al momento de la formalización. En breve, nuestro asesor de financiamiento se pondrá en contacto contigo.</div>
            </div>
        </div>)
    }

    render() {
        const {allQuotationInsurances, insuranceSelectedTarget, hasIncludeInsurance, allQuotationFiltered} = this.props;
        const {showErrors, selectInsuranceError} = this.state;
        return (
            <React.Fragment>
                <div className="row mb-3 d-none d-sm-none d-md-block">
                    <div className="col">
                        <h3 className="title-step text-raleway">{LOAN_APPLICATION_MX.INSURANCE}</h3>
                    </div>
                </div>

                { allQuotationFiltered.length > 0 && <div className="row">
                    <div className="col-12">
                        <Options
                            id={INPUTS.INCLUDE_INSURANCE}
                            name={INPUTS.INCLUDE_INSURANCE}
                            options={this.props.insuranceIncludesOptions}
                            onChange={this.onChangeIncludeInsurance} defaultValue={hasIncludeInsurance}/>
                        {this.props.hasInsuranceError &&
                            <div className="row justify-content-end">
                                <div className="col-12 form-text is-invalid pb-3">
                                    {ERROR.NO_BITUAJ_RESULT_FOR_THIS_VEHICLE_WARNING.toUpperCase()}
                                </div>
                            </div>
                        }
                    </div>
                </div> }

                <div className="insurance-wrapper">
                    { allQuotationFiltered.length > 0 && <div className="row step-section-title align-items-center mt-1 mb-3">
                        <div className="col-12">
                            <div className="header-bar">{LOAN_APPLICATION_MX.INSURANCE_COMPANIES}</div>
                        </div>
                    </div> }

                    {allQuotationInsurances.length === 0 && this.props.hasIncludeInsurance ?
                        this.showInsuranceLoader() :
                        allQuotationFiltered.length === 0 ?
                            this.renderEmptyQuotations() :
                            this.renderQuotations(allQuotationFiltered,
                                insuranceSelectedTarget,
                                hasIncludeInsurance,
                                showErrors,
                                selectInsuranceError)
                    }
                </div>

                <div className="row border-top pt-4 mb-3">
                    <div className="col-12 d-flex justify-content-between">
                        <Button
                            text={this.props.returnToSummary ? LOAN_APPLICATION_MX.UPDATE : LOAN_APPLICATION_MX.NEXT}
                            onPress={() => this.onPressNext(true)} role="button"
                            disabled={hasIncludeInsurance && allQuotationInsurances.length === 0}
                            customClass="ml-auto px-md-5 btn-block"/>
                    </div>
                </div>

            </React.Fragment>
        );
    }
}

export default InsurancesStepView;
